/* Vinterglød — shared scroll motion controller.
 * Handles scroll-triggered reveal animations and animated count-up on real
 * spec numbers. Purely a progressive enhancement layer: every number and
 * every section is already correct and fully visible in the server-rendered
 * HTML — this script only adds motion on top of that.
 */
(function () {
  if (window.__vgMotionInit) return;
  window.__vgMotionInit = true;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var supportsIO = 'IntersectionObserver' in window;

  if (!prefersReducedMotion && supportsIO) {
    document.documentElement.classList.add('vg-motion-armed');
  }

  function easeOutExpo(t) {
    return t >= 1 ? 1 : 1 - Math.pow(2, -10 * t);
  }

  function formatNumber(value, decimals) {
    return value.toFixed(decimals);
  }

  function animateCount(el) {
    if (el.__vgCounted) return;
    el.__vgCounted = true;

    var target = parseFloat(el.getAttribute('data-vg-count'));
    if (isNaN(target)) return;

    if (prefersReducedMotion) return; // real number is already server-rendered

    var decimals = parseInt(el.getAttribute('data-vg-decimals') || '0', 10);
    var suffix = el.getAttribute('data-vg-suffix') || '';
    var prefix = el.getAttribute('data-vg-prefix') || '';
    var duration = 1300;
    var start = null;

    function step(timestamp) {
      if (start === null) start = timestamp;
      var progress = Math.min((timestamp - start) / duration, 1);
      var eased = easeOutExpo(progress);
      var value = target * eased;
      el.textContent = prefix + formatNumber(value, decimals) + suffix;
      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        el.textContent = prefix + formatNumber(target, decimals) + suffix;
      }
    }

    window.requestAnimationFrame(step);
  }

  function initMotion(root) {
    var scope = root || document;
    var revealEls = scope.querySelectorAll('[data-vg-reveal]');
    var countEls = scope.querySelectorAll('[data-vg-count]');

    if (!supportsIO) {
      // No animation support: leave everything exactly as server-rendered.
      return;
    }

    if (revealEls.length) {
      var revealObserver = new IntersectionObserver(
        function (entries, observer) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('vg-in-view');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
      );
      revealEls.forEach(function (el) {
        revealObserver.observe(el);
      });
    }

    if (countEls.length && !prefersReducedMotion) {
      var countObserver = new IntersectionObserver(
        function (entries, observer) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              animateCount(entry.target);
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.4 }
      );
      countEls.forEach(function (el) {
        countObserver.observe(el);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initMotion();
    });
  } else {
    initMotion();
  }

  // Theme editor: re-run when a section is re-rendered.
  document.addEventListener('shopify:section:load', function (event) {
    initMotion(event.target);
  });
})();
